/**
 * Single shared HTML-escaping util (#1527) — replaces ~9 divergent local copies that had
 * accreted across the skin port, one per stage/shell widget that interpolates kernel-sourced
 * strings into `innerHTML` template literals. Roughly half those copies only escaped
 * `[&<>"]` (dropping the apostrophe), which is a real correctness/XSS-adjacent gap: an
 * unescaped `'` inside an attribute delimited with single quotes (or inside inline
 * JS/HTML the browser's parser can otherwise be confused by) still lets attacker-controlled
 * content break out of its intended context. This util always escapes the full set — `&`,
 * `<`, `>`, `"`, and `'` — so every call site gets the more complete behavior regardless of
 * which of the old copies it used to carry.
 */
const ESCAPE_MAP = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#39;",
};
export function escapeHtml(value) {
    return value.replace(/[&<>"']/gu, (character) => ESCAPE_MAP[character] ?? character);
}
//# sourceMappingURL=escape-html.js.map